// Only EN and NL translations have been reviewed and confirmed. Other languages are commented out
// until they are verified.
import en from './en.json';
import nl from './nl.json';
// import de from './de.json';
// import fr from './fr.json';
// import es from './es.json';
// import it from './it.json';
// import sv from './sv.json';

export const SUPPORTED_LANGUAGES = ['en', 'nl'] as const;
export default { en, nl } as const;
